// extracted by mini-css-extract-plugin
module.exports = {"search-input-mobile-popup":"search-input-mobile-popup__exjZP"};